import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: BookingCandidateState = {
  bookingCandidate: {
    object_id: '',
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    date_of_birth: '',
    status: ''
  },
  bookingCandidates: null
}

const getters: GetterTree<BookingCandidateState, RootState> = {

}

const actions: ActionTree<BookingCandidateState, RootState> = {
  fetch({ commit }, oid) {
    return http.v1.bcan.fetch(oid, {
      params: {
        expand: [
          'booking',
          'booking.questionnaire',
          'booking.request_business',
          'booking.risk_profile',
          'questionnaire_answer',
        ]
      }
    }).then(response => {
      const payload = response.data.data
      commit('SET_BOOKING_CANDIDATE', payload)
      return response
    })
  },
  sendNotification(context, { object_id, body }) {
    return http.v1.bcan.sendNotification(object_id, body)
  },
  candidate(context, oid) {
    return http.v1.bcan.candidate(oid)
  },
  update(context, bookingCandidate) {
    return http.v1.bcan.update(bookingCandidate.object_id, bookingCandidate)
  },
  fetchList({ commit }, options) {
    return http.v1.bcan.fetchList(options).then(({ data }) => {
      const payload = data
      const items = payload.data.data

      commit('SET_BOOKING_CANDIDATES', items)

      return {
        items,
        total: payload.data.total,
      }
    })
  },
  confirmPolicy(context, oid) {
    return http.v1.bcan.confirmPolicy(oid)
  },
  startQuestionnaire(context, oid) {
    return http.v1.bcan.startQuestionnaire(oid)
  },
  consume({ state }) {
    return http.v1.bcan.consume(state.bookingCandidate.object_id)
  },
}

const mutations: MutationTree<BookingCandidateState> = {
  SET_BOOKING_CANDIDATE(state, payload) {
    state.bookingCandidate = payload
  },
  SET_BOOKING_CANDIDATES(state, payload) {
    state.bookingCandidates = payload
  },
  CLEAR_BOOKING_CANDIDATES(state) {
    state.bookingCandidates = null
  }
}

const bookingCandidate: Module<BookingCandidateState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default bookingCandidate
